import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ColorDot = styled(Box)(({ theme }) => ({
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  cursor: 'pointer',
}));
